import { TAppState, EInternalPackageType } from '../types';
import { selectPackageInternalType } from './buyPackageModal';

export const selectIsModernDesignAvailable = (state: TAppState): boolean => {
  const internalType = selectPackageInternalType(state);
  const { smartPackageRedesignAbGroup } = state.user;

  return (
    (internalType === EInternalPackageType.SmartPackage && smartPackageRedesignAbGroup === 'money_655_new_design') ||
    internalType === EInternalPackageType.PersonalSubscriptionPublication
  );
};
